import { DateTime } from "luxon";
import { useImmer } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { useRequestBulkOperation } from "@src/api/shops/request-bulk-operation";

export const RequestBulkOrders = () => {
  const [startDatetime, setStartDatetime] = useImmer<DateTime | null>(
    DateTime.now().minus({ day: 30 })
  );
  const [endDatetime, setEndDatetime] = useImmer<DateTime | null>(
    DateTime.now()
  );

  const requestBulkOperation = useRequestBulkOperation();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Grid
        container
        wrap={"nowrap"}
        item
        direction="row"
        columnSpacing={3}
        alignItems={"center"}
      >
        <Grid item sx={{ minWidth: "350px" }}>
          <IgTypography>Request Bulk Orders</IgTypography>
        </Grid>
        <Grid item>
          <DatePicker
            disabled={requestBulkOperation.isPending}
            onChange={(newValue) => {
              setStartDatetime(newValue);
            }}
            value={startDatetime}
            sx={{ width: "176px" }}
          />
        </Grid>
        <Grid item>
          <DatePicker
            disabled={requestBulkOperation.isPending}
            onChange={(newValue) => {
              setEndDatetime(newValue);
            }}
            value={endDatetime}
            sx={{ width: "176px" }}
          />
        </Grid>
        <Grid item>
          <IgButton
            sx={{ minWidth: "200px" }}
            variant={"outlined"}
            size={"large"}
            onClick={() =>
              requestBulkOperation.mutate({
                body: {
                  type: "orders",
                  startDatetime:
                    startDatetime?.toFormat("yyyy-MM-dd") ||
                    DateTime.now().minus({ day: 30 }).toFormat("yyyy-MM-dd"),
                  endDatetime:
                    endDatetime?.toFormat("yyyy-MM-dd") ||
                    DateTime.now().toFormat("yyyy-MM-dd"),
                },
                pathParams: undefined,
                queryParams: undefined,
              })
            }
            loading={requestBulkOperation.isPending}
          >
            Request Bulk Orders
          </IgButton>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};
